interface IRoleData {
    id: string;
    name: string;
    composite: boolean;
    clientRole: boolean;
    containerId: string;
}

interface ILanguageData {
    id: string;
    name: string;
}

interface IReportData {
    id: string;
    name: string;
}

export interface userPostData {
    userFormData: IUserFormData;
    roleData: IRoleList | any;
    oldRoleData?: any;
}

export interface IRoleList {
    clientRoles: IRoleData[];
    realmRoles: IRoleData[];
}

export const defaultRoleData = {
    clientRoles: [{
        id: "",
        name: "",
        composite: false,
        clientRole: false,
        containerId: ""
    }],
    realmRoles: [{
        id: "",
        name: "",
        composite: false,
        clientRole: false,
        containerId: ""
    }]
}

export default interface IUserFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    isEnabled:boolean;
    firstName: string;
    lastName: string;
    email: string;
    role: IRoleData;
    username: string;
    password: string;
    languagePreferred?: ILanguageData;
    description?: string;
    reportTemplate?: IReportData;
}

export class UserFormData implements IUserFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    isEnabled:boolean;
    firstName: string;
    lastName: string;
    email: string;
    role: IRoleData;
    username: string;
    password: string;
    languagePreferred?: ILanguageData;
    description?: string;
    reportTemplate?: IReportData;
    

    constructor(isEditMode: boolean,
        requestId: string,
        id: string,
        isEnabled:boolean,
        firstName: string,
        lastName: string,
        email: string,
        role: IRoleData,
        username: string,
        password: string,
        languagePreferred?: ILanguageData,
        description?: string,
        reportTemplate?: IReportData,
       ) {
            
        this.isEditMode = isEditMode;
        this.requestId = requestId;
        this.id = id;
        this.isEnabled = true;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.role = role;
        this.username = username;
        this.password = password;
    }
}
